import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ee1e263"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArtefactShapedImage = _resolveComponent("ArtefactShapedImage")!

  return (_ctx.images && _ctx.showImages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "transition_image__container",
            key: `image-${index}`
          }, [
            _createVNode(_component_ArtefactShapedImage, {
              url: image.src,
              template: index
            }, null, 8, ["url", "template"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}